import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'seal-status-banner',
    templateUrl: './seal-status-banner.component.html',
    styleUrls: ['./seal-status-banner.component.scss'],
})
export class SealStatusBannerComponent {
    @Input() isSealed: boolean = false;
    @Input() sealedAt: Date | null = null;
    @Input() sealedBy: string | null = null;
    @Input() hasSealHistory: boolean = false;

    @Output() sealClicked = new EventEmitter<void>();
    @Output() unsealClicked = new EventEmitter<void>();
    @Output() auditLogClicked = new EventEmitter<void>();
}
